module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alertBox"
  }, _vm._l((_vm.reverseModalNotifications), function(notification, index) {
    return _c('notification', {
      key: index,
      attrs: {
        "notification": notification,
        "position": index
      },
      on: {
        "close": function($event) {
          return _vm.closeNotification(index)
        }
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33c621d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalNotifications.vue
// module id = 1314
// module chunks = 16